import React, { useState } from "react";
import { Form, Select } from "antd";
import { useQuery } from "@apollo/client";
import { GET_EMAIL_CHANNELS_CURSOR } from "graphql/query/email-channel-gql";
import Icons from "components/icons";
import { cursorPagination, Localize } from "components/service";
import { useDebounce } from "components/use-hooks";
import type { TEmailChannel } from "../../helpers/email-channel-types-helper";

interface IEmailChannelEmailSelectProps {
  channel?: TEmailChannel;
}

const EmailChannelEmailSelect: React.FC<IEmailChannelEmailSelectProps> = ({
  channel,
}) => {
  const [searchText, setSearchText] = useState("");
  const where = {
    column: "EXHIBITION_TYPE_ID",
    operator: "IS_NULL",
  };

  const { data, loading, fetchMore } = useQuery(GET_EMAIL_CHANNELS_CURSOR, {
    variables: {
      text: useDebounce(searchText),
      first: 50,
      where,
      orderBy: [{ column: "USERNAME", order: "ASC" }],
    },
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    notifyOnNetworkStatusChange: true,
  });

  const { node, onPopupScroll } = cursorPagination({
    model: "emailChannelsCursor",
    data,
    loading,
    fetchMore,
  });
  const availableOptions = node.map(({ node: emailChannel }) => ({
    value: emailChannel.id,
    label: emailChannel.username,
  }));
  const options = channel
    ? [
        {
          value: channel.id,
          label: channel.username,
        },
        ...availableOptions.filter(({ value }) => value !== channel.id),
      ]
    : availableOptions;

  return (
    <Form.Item
      name="id"
      label={<Localize>EMAIL_CHANNEL.Form_Label_Email</Localize>}
      rules={[
        {
          required: true,
          message: <Localize>EMAIL_CHANNEL.Form_Required_Email</Localize>,
        },
      ]}
    >
      <Select
        showSearch
        suffixIcon={<Icons.Arrow />}
        filterOption={false}
        loading={loading}
        options={options}
        onSearch={setSearchText}
        onPopupScroll={onPopupScroll}
        placeholder={<Localize>EMAIL_CHANNEL.Form_Placeholder_Email</Localize>}
      />
    </Form.Item>
  );
};

export default EmailChannelEmailSelect;
